if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"WPPOpenCoreOS","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(08|345|625|992)|3(338|44|543|96)|4(24|307|803)|8(411|579|713|87)|[79]228|6693|7081)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}